import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Check_svg from "./Check_svg";

const sliderSettings = {
  dots: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  //   centerMode: true,
  // centerPadding: '3%',
};

const Documents = () => {
  return (
    <article className="document_section">
      <div className="container">
        <h2 className="mb-2">Documents</h2>
        {/* desktop view */}
        <div className="docwrapper d-md-block d-none my-lg-5 my-3">
          <div className="row ">
            <div className="col-5 headingbg border-white">
              <p>Document Required</p>
            </div>
            <div className="col-2 headingbg border-white">
              <p>Salaried</p>
            </div>
            <div className="col-2 headingbg border-white">
              <p>Self employed</p>
            </div>
            <div className="col-3 headingbg border-white">
              <p>Self employed professional</p>
            </div>
          </div>
          <div className="row kyc_text text-center">
            <p>KYC and other documents required for all categories</p>
          </div>
          <div className="row ">
            <div className="col-5 border border-top-0">
              <p>Application form with photograph duly signed</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-3 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
          </div>
          <div className="row ">
            <div className="col-5 border border-top-0">
              <p>KYC documents: Age proof, PAN, Signature proof</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-3 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
          </div>
          <div className="row ">
            <div className="col-5 border border-top-0">
              <p>Processing fee</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-3 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
          </div>
          <div className="row ">
            <div className="col-5 border border-top-0">
              <p>Office address proof</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">__</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-3 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
          </div>
          <div className="row ">
            <div className="col-5 border border-top-0">
              <p>Copy of property document</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-3 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
          </div>
          <div className="row ">
            <div className="col-5 border border-top-0">
              <p>Proof odf business stability existence</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">__</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-3 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
          </div>
          <div className="row ">
            <div className="col-5 border border-top-0">
              <p>Business profile for 50L cases</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">__</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-3 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
          </div>
          <div className="row kyc_text text-center">
            <p>Income documents required</p>
          </div>
          <div className="row ">
            <div className="col-5 border border-top-0">
              <p>Latest 6 months bank statement</p>
              <ul>
                <li>Salaried 3 months</li>
                <li>Self employed 6 months</li>
                <li>Not required for ICICI Bank Account</li>
              </ul>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-3 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
          </div>
          <div className="row ">
            <div className="col-5 border border-top-0">
              <p>Latest 1 month salary slip</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">__</p>
            </div>
            <div className="col-3 border border-top-0">
              <p className="text-center">__</p>
            </div>
          </div>
          <div className="row ">
            <div className="col-5 border border-top-0">
              <p>Educational qualification certificates</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">__</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-3 border border-top-0">
              <p className="text-center">__</p>
            </div>
          </div>
          <div className="row ">
            <div className="col-5 border border-top-0">
              <p>Financials</p>
              <ul>
                <li>Computation of income</li>
                <li>
                  Balance sheet of profit and loss account(with Schedules and
                  Audit)
                </li>
              </ul>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">__</p>
            </div>
            <div className="col-2 border border-top-0">
              <div className="row">
                <div className="col-12 border border-top-0 ">
                  <p className="text-center">
                    <Check_svg />
                  </p>
                </div>
                <div className="col-12 border border-top-0 ">
                  <p className="text-center">LAP - 2 Years</p>
                </div>
                <div className="col-12 border border-top-0 ">
                  <p className="text-center">Other - 2 Years</p>
                </div>
              </div>
            </div>
            <div className="col-3 border border-top-0">
              <div className="row">
                <div className="col-12 border border-top-0 ">
                  <p className="text-center">
                    <Check_svg />
                  </p>
                </div>
                <div className="col-12 border border-top-0 ">
                  <p className="text-center">LAP - 2 Years</p>
                </div>
                <div className="col-12 border border-top-0 ">
                  <p className="text-center">Other - 2 Years</p>
                </div>
              </div>
            </div>
          </div>
          <div className="row kyc_text text-center">
            <p>Additional documents for LRD</p>
          </div>
          <div className="row ">
            <div className="col-5 border border-top-0">
              <p>Copy of Lease agreement</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-3 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
          </div>
          <div className="row ">
            <div className="col-5 border border-top-0">
              <p>Copy of the Bank Statement Reflecting Rental Credits</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-3 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
          </div>
        </div>

        {/* mobile view */}
        <div className="docwrapper d-md-none d-block my-lg-5 my-3">
          <div className="row rowstrip">
            <div className="col-5 headingbg border-white">
              <p>Document Required</p>
            </div>
            <div className="col-2 headingbg border-white">
              <p>Salaried</p>
            </div>
            <div className="col-2 headingbg border-white">
              <p>Self employed</p>
            </div>
            <div className="col-3 headingbg border-white">
              <p>Self employed professional</p>
            </div>
          </div>
          <div className="row  kyc_text text-center">
            <div className="col-12">
              <p>KYC and other documents required for all categories</p>
            </div>
          </div>
          <div className="row rowstrip">
            <div className="col-5 border border-top-0">
              <p>Application form with photograph duly signed</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-3 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
          </div>
          <div className="row rowstrip ">
            <div className="col-5 border border-top-0">
              <p>KYC documents: Age proof, PAN, Signature proof</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-3 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
          </div>
          <div className="row rowstrip ">
            <div className="col-5 border border-top-0">
              <p>Processing fee</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-3 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
          </div>
          <div className="row rowstrip">
            <div className="col-5 border border-top-0">
              <p>Office address proof</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">__</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-3 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
          </div>
          <div className="row rowstrip">
            <div className="col-5 border border-top-0">
              <p>Copy of property document</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-3 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
          </div>
          <div className="row rowstrip">
            <div className="col-5 border border-top-0">
              <p>Proof odf business stability existence</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">__</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-3 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
          </div>
          <div className="row rowstrip">
            <div className="col-5 border border-top-0">
              <p>Business profile for 50L cases</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">__</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-3 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
          </div>
          <div className="row  kyc_text text-center">
            <p>Income documents required</p>
          </div>
          <div className="row rowstrip ">
            <div className="col-5 border border-top-0">
              <p>Latest 6 months bank statement</p>
              <ul>
                <li>Salaried 3 months</li>
                <li>Self employed 6 months</li>
                <li>Not required for ICICI bank account</li>
              </ul>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-3 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
          </div>
          <div className="row rowstrip">
            <div className="col-5 border border-top-0">
              <p>Latest 1 month salary slip</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">__</p>
            </div>
            <div className="col-3 border border-top-0">
              <p className="text-center">__</p>
            </div>
          </div>
          <div className="row rowstrip">
            <div className="col-5 border border-top-0">
              <p>Educational qualification certificates</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">__</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-3 border border-top-0">
              <p className="text-center">__</p>
            </div>
          </div>
          <div className="row rowstrip">
            <div className="col-5 border border-top-0">
              <p>Financials</p>
              <ul>
                <li>Computation of income</li>
                <li>
                  Balance sheet of profit and loss account(with Schedules and
                  Audit)
                </li>
              </ul>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">__</p>
            </div>
            <div className="col-2 border border-top-0">
              <div className="row">
                <div className="col-12 border border-top-0 ">
                  <p className="text-center">
                    <Check_svg />
                  </p>
                </div>
                <div className="col-12 border border-top-0 ">
                  <p className="text-center">LAP - 2 Years</p>
                </div>
                <div className="col-12 border border-top-0 ">
                  <p className="text-center">Other - 2 Years</p>
                </div>
              </div>
            </div>
            <div className="col-3 border border-top-0">
              <div className="row">
                <div className="col-12 border border-top-0 ">
                  <p className="text-center">
                    <Check_svg />
                  </p>
                </div>
                <div className="col-12 border border-top-0 ">
                  <p className="text-center">LAP - 2 Years</p>
                </div>
                <div className="col-12 border border-top-0 ">
                  <p className="text-center">Other - 2 Years</p>
                </div>
              </div>
            </div>
          </div>
          <div className="row  kyc_text text-center">
            <p>Additional documents for LRD</p>
          </div>
          <div className="row rowstrip">
            <div className="col-5 border border-top-0">
              <p>Copy of Lease agreement</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-3 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
          </div>
          <div className="row rowstrip">
            <div className="col-5 border border-top-0">
              <p>Copy of the Bank Statement Reflecting Rental Credits</p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-2 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
            <div className="col-3 border border-top-0">
              <p className="text-center">
                <Check_svg />
              </p>
            </div>
          </div>
        </div>

        <div className="document_wrapper my-5">
          {/* desktop view  */}
          <div className="row justify-content-evenly d-md-flex d-none">
            <div className="col-md-2 doc_wrap pb-4 pb-md-0 d-flex justify-md-content-center flex-md-column ">
              <div className="document_img">
                <img
                  src="dist/img/LAP_for_doctors.webp"
                  alt="ICICI Bank"
                  width="343"
                  height="223"
                  className="img-fluid"
                />
              </div>
              <div className="document_content">
                <h3>LAP for Doctors</h3>
                <p>
                  ICICI Bank's LAP for Doctors is a tailored financing solution designed to help medical professionals like you unlock the potential of your property. With a loan sanction of up to 75% of your property's value, you can access the funds you need to take your medical practice to the next level. Plus, with a loan term of up to 15 years, you can enjoy a flexible repayment tenure that aligns with your financial goals.
                </p>
              </div>
            </div>
            <div className="col-md-2 doc_wrap pb-4 pb-md-0 d-flex justify-md-content-center flex-md-column ">
              <div className="document_img">
                <img
                  src="dist/img/home_overdraft.webp"
                  alt="ICICI Bank"
                  width="343"
                  height="223"
                  className="img-fluid"
                />
              </div>
              <div className="document_content">
                <h3>Home Overdraft</h3>
                <p>
                  Experience the flexibility of a credit limit with ICICI Bank's Loan Against Property Overdraft (Home OD) or LAP OD facility. This financing option allows you to withdraw funds as needed from your sanctioned limit, providing you with the freedom to manage your finances according to your requirements. As a long-term dropline limit, your facility will be auto-renewed annually at minimal renewal charges. Plus, interest is only applicable on the utilised amount, ensuring you only pay for what you need.
                </p>
              </div>
            </div>
            <div className="col-md-2 doc_wrap mt-5 mt-lg-0 pb-4 pb-md-0 d-flex justify-md-content-center flex-md-column ">
              <div className="document_img">
                <img
                  src="dist/img/LAP_topup.webp"
                  alt="ICICI Bank"
                  width="343"
                  height="223"
                  className="img-fluid"
                />
              </div>
              <div className="document_content">
                <h3>LAP Top-up</h3>
                <p>
                  Boost your existing Loan Against Property with a convenient Top-up Loan from ICICI Bank. Whether you're facing a financial shortfall for personal or business needs, a Top-up Loan is the perfect solution. With minimal and simple documentation required, especially if you already have an ongoing LAP, you can easily access additional funds to meet your requirements.
                </p>
              </div>
            </div>
          </div>

          {/* mobile view */}
          <div className="row justify-content-between d-md-none d-block">
            <Slider {...sliderSettings}>
              <div className="col-md-2 doc_wrap pb-4 pb-md-0 justify-md-content-center  ">
                <div className="document_img">
                  <img
                    src="dist/img/LAP_for_doctors.webp"
                    alt="ICICI Bank"
                    width="343"
                    height="223"
                    className="img-fluid"
                  />
                </div>
                <div className="document_content">
                  <h3>LAP for Doctors</h3>
                  <p>
                    ICICI Bank's LAP for Doctors is a tailored financing solution designed to help medical professionals like you unlock the potential of your property. With a loan sanction of up to 75% of your property's value, you can access the funds you need to take your medical practice to the next level. Plus, with a loan term of up to 15 years, you can enjoy a flexible repayment tenure that aligns with your financial goals.
                  </p>
                </div>
              </div>
              <div className="col-md-2 doc_wrap pb-4 pb-md-0 justify-md-content-center  ">
                <div className="document_img">
                  <img
                    src="dist/img/home_overdraft.webp"
                    alt="ICICI Bank"
                    width="343"
                    height="223"
                    className="img-fluid"
                  />
                </div>
                <div className="document_content">
                  <h3>Home Overdraft</h3>
                  <p>
                    Experience the flexibility of a credit limit with ICICI Bank's Loan Against Property Overdraft (Home OD) or LAP OD facility. This financing option allows you to withdraw funds as needed from your sanctioned limit, providing you with the freedom to manage your finances according to your requirements. As a long-term dropline limit, your facility will be auto-renewed annually at minimal renewal charges. Plus, interest is only applicable on the utilised amount, ensuring you only pay for what you need.
                  </p>
                </div>
              </div>
              <div className="col-md-2 doc_wrap pb-4 pb-md-0 justify-md-content-center  ">
                <div className="document_img">
                  <img
                    src="dist/img/LAP_topup.webp"
                    alt="ICICI Bank"
                    width="343"
                    height="223"
                    className="img-fluid"
                  />
                </div>
                <div className="document_content">
                  <h3>LAP Top-up</h3>
                  <p>
                    Boost your existing Loan Against Property with a convenient Top-up Loan from ICICI Bank. Whether you're facing a financial shortfall for personal or business needs, a Top-up Loan is the perfect solution. With minimal and simple documentation required, especially if you already have an ongoing LAP, you can easily access additional funds to meet your requirements.
                  </p>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </div>
    </article>
  );
};

export default Documents;
